import { render, staticRenderFns } from "./AppSupport.vue?vue&type=template&id=74e3cd4a&"
import script from "./AppSupport.vue?vue&type=script&lang=js&"
export * from "./AppSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports